import { ThemeDefinition } from 'vuetify'

const brelagThemeColors = {
  source: '#1D77B6',
  primary0: '#000000',
  primary10: '#001d33',
  primary20: '#003354',
  primary25: '#003e65',
  primary30: '#004a77',
  primary35: '#005689',
  primary40: '#00639c',
  primary50: '#257cbc',
  primary60: '#4896d7',
  primary70: '#66b1f4',
  primary80: '#98cbff',
  primary90: '#cee5ff',
  primary95: '#e8f2ff',
  primary98: '#f7f9ff',
  primary99: '#fcfcff',
  primary100: '#ffffff',
  secondary0: '#000000',
  secondary10: '#001f26',
  secondary20: '#003640',
  secondary25: '#00424e',
  secondary30: '#004e5c',
  secondary35: '#005b6b',
  secondary40: '#00687a',
  secondary50: '#008399',
  secondary60: '#009eb9',
  secondary70: '#2dbad7',
  secondary80: '#55d6f4',
  secondary90: '#acedff',
  secondary95: '#d8f6ff',
  secondary98: '#f0fbff',
  secondary99: '#f8fdff',
  secondary100: '#ffffff',
  tertiary0: '#000000',
  tertiary10: '#001d33',
  tertiary20: '#003354',
  tertiary25: '#003e65',
  tertiary30: '#004a77',
  tertiary35: '#005689',
  tertiary40: '#00639c',
  tertiary50: '#257cbc',
  tertiary60: '#4896d7',
  tertiary70: '#66b1f4',
  tertiary80: '#98cbff',
  tertiary90: '#cee5ff',
  tertiary95: '#e8f2ff',
  tertiary98: '#f7f9ff',
  tertiary99: '#fcfcff',
  tertiary100: '#ffffff',
  neutral0: '#000000',
  neutral10: '#001f2a',
  neutral20: '#003547',
  neutral25: '#004156',
  neutral30: '#004d65',
  neutral35: '#005975',
  neutral40: '#006685',
  neutral50: '#0081a7',
  neutral60: '#119cc8',
  neutral70: '#43b7e5',
  neutral80: '#6cd2ff',
  neutral90: '#bfe9ff',
  neutral95: '#e1f4ff',
  neutral98: '#f4faff',
  neutral99: '#fafcff',
  neutral100: '#ffffff',
  'neutral-variant0': '#000000',
  'neutral-variant10': '#171c22',
  'neutral-variant20': '#2c3137',
  'neutral-variant25': '#373c42',
  'neutral-variant30': '#42474e',
  'neutral-variant35': '#4e535a',
  'neutral-variant40': '#5a5f66',
  'neutral-variant50': '#72777f',
  'neutral-variant60': '#8c9199',
  'neutral-variant70': '#a7abb3',
  'neutral-variant80': '#c2c7cf',
  'neutral-variant90': '#dee3eb',
  'neutral-variant95': '#edf1f9',
  'neutral-variant98': '#f7f9ff',
  'neutral-variant99': '#fcfcff',
  'neutral-variant100': '#ffffff',
  error0: '#000000',
  error10: '#410002',
  error20: '#690005',
  error25: '#7e0007',
  error30: '#93000a',
  error35: '#a80710',
  error40: '#ba1a1a',
  error50: '#de3730',
  error60: '#ff5449',
  error70: '#ff897d',
  error80: '#ffb4ab',
  error90: '#ffdad6',
  error95: '#ffedea',
  error98: '#fff8f7',
  error99: '#fffbff',
  error100: '#ffffff',
}

const brelagLightThemeColors = {
  primary: '#006AB4',
  'on-primary': '#ffffff',
  'primary-container': '#cee5ff',
  'on-primary-container': '#001d33',
  secondary: '#00687a',
  'on-secondary': '#ffffff',
  'secondary-container': '#acedff',
  'on-secondary-container': '#001f26',
  tertiary: '#00639c',
  'on-tertiary': '#ffffff',
  'tertiary-container': '#cee5ff',
  'on-tertiary-container': '#001d33',
  error: '#ba1a1a',
  'error-container': '#ffdad6',
  'on-error': '#ffffff',
  'on-error-container': '#410002',
  background: '#fafcff',
  'on-background': '#001f2a',
  surface: '#fafcff',
  'on-surface': '#001f2a',
  'surface-variant': '#dee3eb',
  'on-surface-variant': '#42474e',
  outline: '#424648',

  'inverse-on-surface': '#e1f4ff',
  'inverse-surface': '#003547',
  'inverse-primary': '#98cbff',
  shadow: '#000000',
  'surface-tint': '#00639c',
  'outline-variant': '#c2c7cf',
  scrim: '#000000',
}

const brelagDarkThemeColors = {
  primary: '#98cbff',
  'on-primary': '#003354',
  'primary-container': '#004a77',
  'on-primary-container': '#cee5ff',
  secondary: '#55d6f4',
  'on-secondary': '#003640',
  'secondary-container': '#004e5c',
  'on-secondary-container': '#acedff',
  tertiary: '#98cbff',
  'on-tertiary': '#003354',
  'tertiary-container': '#004a77',
  'on-tertiary-container': '#cee5ff',
  error: '#ffb4ab',
  'error-container': '#93000a',
  'on-error': '#690005',
  'on-error-container': '#ffdad6',
  background: '#001f2a',
  'on-background': '#bfe9ff',
  surface: '#001f2a',
  'on-surface': '#bfe9ff',
  'surface-variant': '#42474e',
  'on-surface-variant': '#c2c7cf',
  outline: '#8c9199',
  'inverse-on-surface': '#001f2a',
  'inverse-surface': '#bfe9ff',
  'inverse-primary': '#00639c',
  shadow: '#000000',
  'surface-tint': '#98cbff',
  'outline-variant': '#42474e',
  scrim: '#000000',
}

export const brelagLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    ...brelagThemeColors,
    ...brelagLightThemeColors,
  },
}

export const brelagDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    ...brelagThemeColors,
    ...brelagDarkThemeColors,
  },
}
